<template>
  <div v-if="planIdentity">
    <v-form ref="planIdentityForm" v-model="valid">
      <v-container fluid grid-list-md>
        <material-card
          :title="$t('components.plancreationwizard.plan_information')"
          :color="$vuetify.theme.themes.light.secondary"
          icon="info"
        >
          <v-card-text>
            <v-layout row wrap>
              <v-col cols="12" sm="6" md="3" class="pt-0 pb-0">
                <tooltip-textbox
                  v-if="edit"
                  :disabled="true"
                  :value.sync="planIdentity.UniqueIdentifier"
                  :label="$t('components.plancreationwizard.unique_identifier')"
                  :rules="[$rules.required]"
                  :tooltipText="
                    $t('views.plangeneralparameters.unique_identifier_tooltip')
                  "
                  class="required"
                ></tooltip-textbox>
                <template v-else>
                  {{ $t("components.plancreationwizard.unique_identifier") }}
                  <br />
                  <span class="minfo">
                    {{ planIdentity.UniqueIdentifier }}
                  </span>
                </template>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="pt-0 pb-0">
                <trans-field
                  v-if="edit"
                  v-model="planIdentity.Current"
                  :label="$t('globals.name')"
                  field="Name"
                ></trans-field>
                <template v-else>
                  {{ $t("globals.name") }}
                  <br />
                  <span class="minfo">
                    {{ translate2(planIdentity.Current, "Name") }}
                  </span>
                </template>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="pt-0 pb-0">
                <v-tooltip bottom v-if="edit">
                  <template v-slot:activator="{ on, attrs }">
                    <v-container pa-0>
                      <v-row no-gutters>
                        <v-col>
                          <pbas-date-picker
                            :value="planIdentity.PlanEffectiveDate"
                            @update-date="
                              planIdentity.PlanEffectiveDate = $event
                            "
                            :label="
                              $t(
                                'views.plangeneralparameters.plan_effective_date'
                              )
                            "
                            disabled
                          ></pbas-date-picker>
                        </v-col>
                        <v-col
                          style="margin-top: 20px; margin-left: 3px"
                          cols="auto"
                        >
                          <v-icon v-bind="attrs" v-on="on">help</v-icon>
                        </v-col>
                      </v-row>
                    </v-container>
                  </template>
                  <span>
                    {{ $t("views.plangeneralparameters.date_tooltip") }}
                  </span>
                </v-tooltip>
                <template v-else>
                  {{ $t("views.plangeneralparameters.plan_effective_date") }}
                  <br />
                  <span class="minfo">
                    {{ formatDate(planIdentity.PlanEffectiveDate) }}
                  </span>
                </template>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="pt-0 pb-0">
                <v-tooltip bottom v-if="edit">
                  <template v-slot:activator="{ on, attrs }">
                    <v-container pa-0>
                      <v-row no-gutters>
                        <v-col>
                          <pbas-date-picker
                            :value="planIdentity.Current.EffectiveDate"
                            @update-date="
                              planIdentity.Current.EffectiveDate = $event
                            "
                            :label="
                              $t('components.plancreationwizard.effective_date')
                            "
                            disabled
                          ></pbas-date-picker>
                        </v-col>
                        <v-col
                          style="margin-top: 20px; margin-left: 3px"
                          cols="auto"
                        >
                          <v-icon v-bind="attrs" v-on="on">help</v-icon>
                        </v-col>
                      </v-row>
                    </v-container>
                  </template>
                  <span>
                    {{
                      $t("views.plangeneralparameters.effective_date_tooltip")
                    }}
                  </span>
                </v-tooltip>
                <template v-else>
                  {{ $t("components.plancreationwizard.effective_date") }}
                  <br />
                  <span class="minfo">
                    {{ formatDate(planIdentity.Current.EffectiveDate) }}
                  </span>
                </template>
              </v-col>
            </v-layout>
            <v-layout row wrap>
              <v-col cols="12" md="6" class="pt-0 pb-0">
                <trans-textarea
                  v-if="edit"
                  v-model="planIdentity.Current"
                  :label="$t('globals.description')"
                  field="Description"
                  :disabled="true"
                ></trans-textarea>
                <template v-else>
                  <div class="col-12 col-md-4 col-lg-3 col-xl-2">
                    {{ $t("globals.description") }}
                    <br />
                    <span class="minfo">
                      {{ translate2(planIdentity.Current, "Description") }}
                    </span>
                  </div>
                </template>
              </v-col>
              <v-col cols="12" md="6" class="pt-0 pb-0">
                <v-layout row wrap>
                  <v-col cols="12" class="pt-0 pb-0">
                    <v-tooltip bottom v-if="edit">
                      <template v-slot:activator="{ on, attrs }">
                        <v-container pa-0>
                          <v-row no-gutters>
                            <v-col>
                              <auto-select
                                :value.sync="planIdentity.Current.Location"
                                :label="
                                  $t('components.plancreationwizard.location')
                                "
                                disabled
                                :items="winZones"
                                item-value="id"
                                item-text="id"
                              ></auto-select>
                            </v-col>
                            <v-col
                              style="margin-top: 20px; margin-left: 3px"
                              cols="auto"
                            >
                              <v-icon v-bind="attrs" v-on="on">help</v-icon>
                            </v-col>
                          </v-row>
                        </v-container>
                      </template>
                      <span>
                        {{ $t("views.plangeneralparameters.location_tooltip") }}
                      </span>
                    </v-tooltip>
                    <template v-else>
                      {{ $t("components.plancreationwizard.location") }}
                      <br />
                      <span class="minfo">
                        {{ planIdentity.Current.Location }}
                      </span>
                    </template>
                  </v-col>
                  <v-col
                    cols="12"
                    class="pt-0 pb-0"
                    v-if="planIdentity.Client.LogoBase64"
                  >
                    <!-- <div class="title">{{$t('views.plangeneralparameters.client_logo')}}</div> -->
                    <image-uploader-string
                      @image-data="
                        planIdentity.Client.LogoBase64 = $event;
                        $forceUpdate();
                      "
                      :image.sync="planIdentity.Client.LogoBase64"
                      :label="$t('components.plancreationwizard.client_logo')"
                    ></image-uploader-string>
                    <!-- <template v-else>
                      {{ $t("components.plancreationwizard.client_logo") }}
                      <br />
                      <span class="minfo">
                        {{ planIdentity.Current.Location }}
                      </span>
                    </template> -->
                  </v-col>
                  <v-col cols="12" class="pt-0 pb-0">
                    <tooltip-textbox
                      v-if="edit"
                      :value.sync="planIdentity.Client.Name"
                      :label="$t('components.plancreationwizard.client_name')"
                      :disabled="true"
                      :tooltipText="
                        $t('views.plangeneralparameters.client_tooltip')
                      "
                    ></tooltip-textbox>
                    <template v-else>
                      {{ $t("components.plancreationwizard.client_name") }}
                      <br />
                      <span class="minfo">
                        {{ planIdentity.Client.Name }}
                      </span>
                    </template>
                  </v-col>
                </v-layout>
              </v-col>
            </v-layout>
          </v-card-text>
        </material-card>
        <template
          v-if="
            selectedPlan.PlanType === 'HW' ||
            selectedPlan.PlanType === 'Pension'
          "
        >
          <material-card
            :title="$t('components.plancreationwizard.plan_settings')"
            :color="$vuetify.theme.themes.light.secondary"
            icon="settings"
            style="margin-top: 30px"
          >
            <v-card-text>
              <v-layout row wrap>
                <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
                  <v-checkbox
                    v-if="edit"
                    v-model="planIdentity.Current.HasPremiums"
                    :label="
                      $t('components.plancreationwizard.include_premiums')
                    "
                    disabled
                  ></v-checkbox>
                  <template v-else>
                    {{ $t("components.plancreationwizard.include_premiums") }}
                    <br />
                    <span class="minfo">
                      {{
                        planIdentity.Current.HasPremiums
                          ? $t("globals.yes")
                          : $t("globals.no")
                      }}
                    </span>
                  </template>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
                  <v-checkbox
                    v-if="edit"
                    v-model="planIdentity.Current.HasBilling"
                    :label="$t('views.plangeneralparameters.include_billing')"
                    disabled
                  ></v-checkbox>
                  <template v-else>
                    {{ $t("views.plangeneralparameters.include_billing") }}
                    <br />
                    <span class="minfo">
                      {{
                        planIdentity.Current.HasBilling
                          ? $t("globals.yes")
                          : $t("globals.no")
                      }}
                    </span>
                  </template>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
                  <v-checkbox
                    v-if="edit"
                    v-model="planIdentity.Current.HasRemittances"
                    :label="
                      $t('components.plancreationwizard.include_remittances')
                    "
                    disabled
                  ></v-checkbox>
                  <template v-else>
                    {{
                      $t("components.plancreationwizard.include_remittances")
                    }}
                    <br />
                    <span class="minfo">
                      {{
                        planIdentity.Current.HasRemittances
                          ? $t("globals.yes")
                          : $t("globals.no")
                      }}
                    </span>
                  </template>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  lg="3"
                  class="pt-0 pb-0"
                  v-if="planIdentity.Current.HasRemittances"
                >
                  <v-checkbox
                    v-if="edit"
                    v-model="planIdentity.Current.HasOperatingFees"
                    :label="
                      $t('components.plancreationwizard.include_operating_fees')
                    "
                    disabled
                  ></v-checkbox>
                  <template v-else>
                    {{
                      $t("components.plancreationwizard.include_operating_fees")
                    }}
                    <br />
                    <span class="minfo">
                      {{
                        planIdentity.Current.HasOperatingFees
                          ? $t("globals.yes")
                          : $t("globals.no")
                      }}
                    </span>
                  </template>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  lg="3"
                  class="pt-0 pb-0"
                  v-if="planIdentity.Current.HasOperatingFees"
                >
                  <v-tooltip bottom v-if="edit">
                    <template v-slot:activator="{ on, attrs }">
                      <v-container pa-0>
                        <v-row no-gutters class="test">
                          <v-col cols="auto">
                            <v-checkbox
                              disabled
                              :class="$attrs['class']"
                              v-model="
                                planIdentity.Current.OperatingFeesPerTerm
                              "
                              :label="
                                $t(
                                  'components.plancreationwizard.operating_fees_per_term'
                                )
                              "
                            ></v-checkbox>
                          </v-col>
                          <v-col
                            style="margin-top: 20px; margin-left: 3px"
                            cols="auto"
                          >
                            <v-icon v-bind="attrs" v-on="on">help</v-icon>
                          </v-col>
                        </v-row>
                      </v-container>
                    </template>
                    <span>
                      {{
                        $t(
                          "components.plancreationwizard.operating_fees_per_term_tooltip"
                        )
                      }}
                    </span>
                  </v-tooltip>
                  <template v-else>
                    {{
                      $t(
                        "components.plancreationwizard.operating_fees_per_term"
                      )
                    }}
                    <br />
                    <span class="minfo">
                      {{
                        planIdentity.Current.OperatingFeesPerTerm
                          ? $t("globals.yes")
                          : $t("globals.no")
                      }}
                    </span>
                  </template>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
                  <v-checkbox
                    v-if="edit"
                    v-model="planIdentity.Current.HasContributions"
                    :label="
                      $t('components.plancreationwizard.include_contributions')
                    "
                    disabled
                  ></v-checkbox>
                  <template v-else>
                    {{
                      $t("components.plancreationwizard.include_contributions")
                    }}
                    <br />
                    <span class="minfo">
                      {{
                        planIdentity.Current.HasContributions
                          ? $t("globals.yes")
                          : $t("globals.no")
                      }}
                    </span>
                  </template>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
                  <v-checkbox
                    v-if="edit"
                    v-model="planIdentity.Current.HasAdminFees"
                    :label="
                      $t('components.plancreationwizard.include_admin_fees')
                    "
                    disabled
                  ></v-checkbox>
                  <template v-else>
                    {{ $t("components.plancreationwizard.include_admin_fees") }}
                    <br />
                    <span class="minfo">
                      {{
                        planIdentity.Current.HasAdminFees
                          ? $t("globals.yes")
                          : $t("globals.no")
                      }}
                    </span>
                  </template>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  lg="3"
                  class="pt-0 pb-0"
                  v-if="planIdentity.Current.HasAdminFees"
                >
                  <v-tooltip bottom v-if="edit">
                    <template v-slot:activator="{ on, attrs }">
                      <v-container pa-0>
                        <v-row no-gutters class="test">
                          <v-col cols="auto">
                            <v-checkbox
                              disabled
                              :class="$attrs['class']"
                              v-model="planIdentity.Current.AdminFeesPerTerm"
                              :label="
                                $t(
                                  'components.plancreationwizard.admin_fees_per_term'
                                )
                              "
                            ></v-checkbox>
                          </v-col>
                          <v-col
                            style="margin-top: 20px; margin-left: 3px"
                            cols="auto"
                          >
                            <v-icon v-bind="attrs" v-on="on">help</v-icon>
                          </v-col>
                        </v-row>
                      </v-container>
                    </template>
                    <span>
                      {{
                        $t(
                          "components.plancreationwizard.admin_fees_per_term_tooltip"
                        )
                      }}
                    </span>
                  </v-tooltip>
                  <template v-else>
                    {{
                      $t("components.plancreationwizard.admin_fees_per_term")
                    }}
                    <br />
                    <span class="minfo">
                      {{
                        planIdentity.Current.AdminFeesPerTerm
                          ? $t("globals.yes")
                          : $t("globals.no")
                      }}
                    </span>
                  </template>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
                  <v-checkbox
                    v-if="edit"
                    v-model="planIdentity.Current.HasPaymentTracking"
                    :label="
                      $t(
                        'components.plancreationwizard.include_payment_tracking'
                      )
                    "
                    disabled
                  ></v-checkbox>
                  <template v-else>
                    {{
                      $t(
                        "components.plancreationwizard.include_payment_tracking"
                      )
                    }}
                    <br />
                    <span class="minfo">
                      {{
                        planIdentity.Current.HasPaymentTracking
                          ? $t("globals.yes")
                          : $t("globals.no")
                      }}
                    </span>
                  </template>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
                  <v-checkbox
                    v-if="edit"
                    v-model="planIdentity.Current.HasStores"
                    :label="$t('components.plancreationwizard.include_stores')"
                    disabled
                  ></v-checkbox>
                  <template v-else>
                    {{ $t("components.plancreationwizard.include_stores") }}
                    <br />
                    <span class="minfo">
                      {{
                        planIdentity.Current.HasStores
                          ? $t("globals.yes")
                          : $t("globals.no")
                      }}
                    </span>
                  </template>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  lg="3"
                  v-if="planIdentity.Current.HasStores"
                  class="pt-0 pb-0"
                >
                  <v-checkbox
                    v-if="edit"
                    v-model="planIdentity.Current.ReportsPerStore"
                    :label="
                      $t('components.plancreationwizard.reports_per_store')
                    "
                    disabled
                  ></v-checkbox>
                  <template v-else>
                    {{ $t("components.plancreationwizard.reports_per_store") }}
                    <br />
                    <span class="minfo">
                      {{
                        planIdentity.Current.ReportsPerStore
                          ? $t("globals.yes")
                          : $t("globals.no")
                      }}
                    </span>
                  </template>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
                  <v-checkbox
                    v-if="edit"
                    v-model="planIdentity.Current.HasT4A"
                    :label="$t('views.plangeneralparameters.include_t4a')"
                    disabled
                  ></v-checkbox>
                  <template v-else>
                    {{ $t("views.plangeneralparameters.include_t4a") }}
                    <br />
                    <span class="minfo">
                      {{
                        planIdentity.Current.HasT4A
                          ? $t("globals.yes")
                          : $t("globals.no")
                      }}
                    </span>
                  </template>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
                  <v-checkbox
                    v-if="edit"
                    v-model="planIdentity.Current.HasDemographics"
                    :label="
                      $t(
                        'views.plangeneralparameters.include_demographics_report'
                      )
                    "
                    disabled
                  ></v-checkbox>
                  <template v-else>
                    {{
                      $t(
                        "views.plangeneralparameters.include_demographics_report"
                      )
                    }}
                    <br />
                    <span class="minfo">
                      {{
                        planIdentity.Current.HasDemographics
                          ? $t("globals.yes")
                          : $t("globals.no")
                      }}
                    </span>
                  </template>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
                  <v-checkbox
                    v-if="edit"
                    v-model="planIdentity.Current.HasPremiumsCheqReqForm"
                    :label="
                      $t(
                        'views.plangeneralparameters.include_premiums_cheque_requisition_form'
                      )
                    "
                    disabled
                  ></v-checkbox>
                  <template v-else>
                    {{
                      $t(
                        "views.plangeneralparameters.include_premiums_cheque_requisition_form"
                      )
                    }}
                    <br />
                    <span class="minfo">
                      {{
                        planIdentity.Current.HasPremiumsCheqReqForm
                          ? $t("globals.yes")
                          : $t("globals.no")
                      }}
                    </span>
                  </template>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
                  <v-checkbox
                    v-if="edit"
                    v-model="planIdentity.Current.HasBeneficiaries"
                    :label="$t('views.plangeneralparameters.has_beneficiaries')"
                    disabled
                  ></v-checkbox>
                  <template v-else>
                    {{ $t("views.plangeneralparameters.has_beneficiaries") }}
                    <br />
                    <span class="minfo">
                      {{
                        planIdentity.Current.HasBeneficiaries
                          ? $t("globals.yes")
                          : $t("globals.no")
                      }}
                    </span>
                  </template>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
                  <v-checkbox
                    v-if="edit"
                    v-model="hasClasses"
                    :label="$t('components.plancreationwizard.has_classes')"
                    disabled
                  ></v-checkbox>
                  <template v-else>
                    {{ $t("components.plancreationwizard.has_classes") }}
                    <br />
                    <span class="minfo">
                      {{ hasClasses ? $t("globals.yes") : $t("globals.no") }}
                    </span>
                  </template>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  lg="3"
                  v-if="hasClasses"
                  class="pt-0 pb-0"
                >
                  <v-tooltip bottom v-if="edit">
                    <template v-slot:activator="{ on, attrs }">
                      <v-container pa-0>
                        <v-row no-gutters>
                          <v-col>
                            <v-combobox
                              :value="classesStr.split(',').filter((e) => e)"
                              @input="
                                classesStr = $event.filter((e) => e).join(',')
                              "
                              hide-selected
                              :label="
                                $t('components.plancreationwizard.classes')
                              "
                              multiple
                              small-chips
                              disabled
                            >
                              <template
                                v-slot:selection="{
                                  attrs,
                                  item,
                                  parent,
                                  selected,
                                }"
                              >
                                <v-chip
                                  v-bind="attrs"
                                  color="primary"
                                  :input-value="selected"
                                  label
                                  small
                                >
                                  <span class="pr-2">
                                    {{ item }}
                                  </span>
                                  <v-icon
                                    small
                                    @click="parent.selectItem(item)"
                                  >
                                    close
                                  </v-icon>
                                </v-chip>
                              </template>
                            </v-combobox>
                          </v-col>
                          <v-col
                            style="margin-top: 20px; margin-left: 3px"
                            cols="auto"
                          >
                            <v-icon v-bind="attrs" v-on="on">help</v-icon>
                          </v-col>
                        </v-row>
                      </v-container>
                    </template>
                    <span>
                      {{ $t("views.plangeneralparameters.classes_tooltip") }}
                    </span>
                  </v-tooltip>
                  <template v-else>
                    {{ $t("components.plancreationwizard.classes") }}
                    <br />
                    <span class="minfo">
                      {{ classesStr }}
                    </span>
                  </template>
                </v-col>
              </v-layout>
            </v-card-text>
          </material-card>
          <material-card
            :title="$t('components.plancreationwizard.admin_fees')"
            :color="$vuetify.theme.themes.light.secondary"
            icon="attach_money"
            v-if="planIdentity.Current.HasOperatingFees"
          >
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col sm="12" md="6">
                    <no-autocomplete-textfield
                      v-if="edit"
                      disabled
                      :label="$t('components.plancreationwizard.account_name')"
                      v-model="planIdentity.Current.OperatingFeesAccountName"
                    />
                    <template v-else>
                      {{ $t("components.plancreationwizard.account_name") }}
                      <br />
                      <span class="minfo">
                        {{ planIdentity.Current.OperatingFeesAccountName }}
                      </span>
                    </template>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </material-card>
          <material-card
            :title="
              $t('components.plancreationwizard.calculation_term_configuration')
            "
            :color="$vuetify.theme.themes.light.secondary"
            icon="schedule"
            style="margin-top: 30px"
          >
            <v-card-text>
              <v-layout row wrap>
                <v-col cols="12" class="pt-0 pb-0">
                  <period-picker
                    :disabled="true"
                    v-model="planIdentity.Current.Term"
                    :label="$t('globals.term')"
                    :timeunitTooltip="
                      $t('views.plangeneralparameters.termunit_tooltip')
                    "
                    :frequencyTooltip="
                      $t('views.plangeneralparameters.frequency_tooltip')
                    "
                    :readOnly="!edit"
                  ></period-picker>
                </v-col>
                <v-col cols="12" sm="12" md="12" class="pt-0 pb-0">
                  <due-picker
                    :disabled="true"
                    :value.sync="planIdentity.Current.DueDate"
                    :daysOfMonth="columnsDropDownOptions.Enums.DayOfMonth"
                    :weekDays="columnsDropDownOptions.Enums.WeekDay"
                    :dueDays="columnsDropDownOptions.Enums.DueDay"
                    :months="columnsDropDownOptions.Enums.Month"
                    :weeks="columnsDropDownOptions.Enums.Week"
                    :dueTimeUnits="columnsDropDownOptions.Enums.DueTimeUnit"
                    :termTimeUnit="planIdentity.Current.Term.TimeUnit"
                    :readOnly="!edit"
                  ></due-picker>
                </v-col>
                <v-col xs="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
                  <tooltip-textbox
                    v-if="edit"
                    :value.sync="planIdentity.Current.BillingOffset"
                    :label="$t('views.plangeneralparameters.billing_offset')"
                    :disabled="true"
                    :tooltipText="
                      $t('components.plancreationwizard.billing_offset_tooltip')
                    "
                  ></tooltip-textbox>
                  <template v-else>
                    {{ $t("views.plangeneralparameters.billing_offset") }}
                    <br />
                    <span class="minfo">
                      {{ planIdentity.Current.BillingOffset }}
                    </span>
                  </template>
                </v-col>
                <v-col xs="12" sm="6" md="4" lg="3" class="pt-0 pb-0">
                  <tooltip-textbox
                    v-if="edit"
                    :value.sync="planIdentity.Current.EligibilityOffset"
                    :label="
                      $t('views.plangeneralparameters.eligibility_offset')
                    "
                    :disabled="true"
                    :tooltipText="
                      $t(
                        'components.plancreationwizard.eligibility_offset_tooltip'
                      )
                    "
                  ></tooltip-textbox>
                  <template v-else>
                    {{ $t("views.plangeneralparameters.eligibility_offset") }}
                    <br />
                    <span class="minfo">
                      {{ planIdentity.Current.EligibilityOffset }}
                    </span>
                  </template>
                </v-col>
              </v-layout>
            </v-card-text>
          </material-card>
        </template>
      </v-container>
    </v-form>
    <v-snackbar
      v-model="snackbar"
      :color="color"
      :multi-line="mode === 'multi-line'"
      :timeout="timeout"
      :vertical="mode === 'vertical'"
    >
      {{ $t(message) }}
      <v-btn dark text @click="snackbar = false">
        {{ $t("globals.close") }}
      </v-btn>
    </v-snackbar>
    <error-handler :error="error"></error-handler>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import PeriodPicker from "@/components/PeriodPicker";
import DuePicker from "@/components/DuePicker";
import ErrorHandler from "@/components/ErrorHandler";
import TransSelect from "@/components/TransSelect";
import TransField from "@/components/TransField";
import TooltipTextbox from "@/components/TooltipTextbox";
import TransTextbox from "@/components/TransTextbox";
import TransTextarea from "@/components/TransTextarea";
import ImageUploaderString from "@/components/ImageUploaderString";
import AutoSelect from "@/components/AutoSelect";
import NoAutocompleteTextfield from "@/components/NoAutocompleteTextfield";
import { translate2 } from "@/trans2";

export default {
  components: {
    ErrorHandler,
    PeriodPicker,
    DuePicker,
    TransSelect,
    TransField,
    TooltipTextbox,
    TransTextbox,
    TransTextarea,
    ImageUploaderString,
    AutoSelect,
    NoAutocompleteTextfield,
  },
  props: ["originalItem", "edit"],
  data() {
    return {
      hasClasses: false,
      error: null,
      saving: false,
      valid: false,
      snackbar: false,
      color: "",
      mode: "",
      timeout: 2500,
      message: "",
      planIdentity: null,
    };
  },
  computed: {
    ...mapGetters("common", ["language", "winZones"]),
    ...mapGetters("auth", ["isLoggedIn", "user"]),
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("plansMembers", { columnsDropDownOptions: "options" }),
  },
  watch: {
    originalItem: {
      handler() {
        this.initialize();
      },
    },
    "planIdentity.PlanDetails.Status": {
      handler(v) {
        if (v) {
          this.planIdentity.PlanDetails.StatusId =
            this.planIdentity.PlanDetails.Status.Id;
        } else {
          this.planIdentity.PlanDetails.StatusId = null;
        }
      },
    },
    "planIdentity.PlanDetails.Term.TimeUnit": {
      handler(v) {
        //console.log("Term.TimeUnit: ", v);
        if (v) {
          if (v === "Week" || v === "Day") {
            this.planIdentity.PlanDetails.DueDate.DueTimeUnit = "Week";
          }
        }
      },
    },
  },
  async mounted() {
    if (this.originalItem !== null && this.originalItem !== undefined) {
      this.initialize();
    }
  },
  methods: {
    ...mapActions("plansMembers", ["updatePlan", "getContributionPlan"]),
    async initialize() {
      this.planIdentity = JSON.parse(JSON.stringify(this.originalItem));

      if (this.planIdentity && this.planIdentity.Current.Classes) {
        this.hasClasses = true;
        this.classesStr = this.planIdentity.Current.Classes.replace(/\[/g, "")
          .replace(/\]/g, "")
          .replace(/"/g, "");
      }
    },
    async save() {
      this.saving = true;
      try {
        let item = JSON.parse(JSON.stringify(this.planIdentity));
        delete item["@odata.context"];
        await this.updatePlan(item);
        this.originalItem = JSON.parse(JSON.stringify(this.planIdentity));
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
    formatDate(dateString) {
      if (dateString === undefined || dateString === null) {
        return "";
      }
      const [date, time] = dateString.split("T");
      const [year, month, day] = date.split("-");
      return `${year}-${month}-${day}`;
    },
    translate2(item, field) {
      return translate2(item, field);
    },
  },
};
</script>

<style>
.full-width {
  width: 100%;
}
.padding-top-14 {
  padding-top: 14px !important;
}
.padding-top-17 {
  padding-top: 17px !important;
}
</style>
<style scoped>
.minfo {
  font-weight: bold;
  color: #222;
}
</style>
